var React = require('react');

function TitleRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.5674 2.56152C11.791 3.17289 6.83369 6.93396 5.60411 6.14356","stroke":"#FF8200","strokeWidth":"3.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M14.6416 15.0278C12.5175 14.8943 10.0796 14.2777 8.04749 14.5852","stroke":"#FF8200","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M12.1114 24.1855C10.2323 23.7913 8.82109 23.2596 7.31704 22.1962","stroke":"#FF8200","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

TitleRight.defaultProps = {"width":"22","height":"27","viewBox":"0 0 22 27","fill":"none"};

module.exports = TitleRight;

TitleRight.default = TitleRight;
